<div class="wrapper">
  <header-component></header-component>
  <banner-component></banner-component>
  <div class="main">
    <router-outlet></router-outlet>
  </div>
  <footer-component></footer-component>
</div>
